function parseDisclaimers({ disclaimers }): Disclaimer[] {
  return Object.keys(disclaimers).map(key => disclaimers[key].details.html)
}

export default parseDisclaimers
